<template>
  <section class="login-page">
    <form class="login-panel" @submit.prevent="submitLogin">
      <div class="login-brand">
        <div class="login-brand__mark">B</div>
        <div>
          <p>Banana Studio</p>
          <h1>账号登录</h1>
        </div>
      </div>

      <div v-if="errorMessage" class="login-error">
        {{ errorMessage }}
      </div>

      <van-cell-group inset class="login-fields">
        <van-field
          v-model="form.email"
          autocomplete="username"
          clearable
          label="邮箱"
          placeholder="请输入邮箱"
          type="email"
        />
        <van-field
          v-model="form.password"
          autocomplete="current-password"
          clearable
          label="密码"
          placeholder="请输入密码"
          type="password"
        />
      </van-cell-group>

      <van-button
        block
        class="login-submit"
        native-type="submit"
        round
        type="primary"
        :loading="loggingIn"
      >
        登录
      </van-button>
    </form>
  </section>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { showToast } from 'vant'

import { loginH5 } from '../api/auth'
import { saveH5Session } from '../utils/auth'

const route = useRoute()
const router = useRouter()
const loggingIn = ref(false)
const errorMessage = ref('')
const form = reactive({
  email: '',
  password: '',
})

function resolveRedirectPath() {
  const redirect = String(route.query.redirect || '').trim()
  if (redirect && redirect.startsWith('/') && !redirect.startsWith('/login')) {
    return redirect
  }
  return '/youtube'
}

async function submitLogin() {
  const email = form.email.trim()
  const password = form.password
  if (!email || !password) {
    errorMessage.value = '请输入邮箱和密码'
    return
  }

  loggingIn.value = true
  errorMessage.value = ''
  try {
    const data = await loginH5({
      email,
      password,
    })
    saveH5Session({
      token: data?.token,
      expiresAt: data?.expiresAt,
      user: data?.user,
    })
    showToast('已登录')
    await router.replace(resolveRedirectPath())
  } catch (error) {
    errorMessage.value = error?.message || '登录失败'
  } finally {
    loggingIn.value = false
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: grid;
  align-items: center;
  padding: calc(env(safe-area-inset-top) + 24px) 18px calc(env(safe-area-inset-bottom) + 24px);
  box-sizing: border-box;
}

.login-panel {
  width: 100%;
}

.login-brand {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 24px;
  padding: 0 4px;
}

.login-brand__mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 16px;
  background: linear-gradient(135deg, #e11d48, #fb7185);
  color: #fff;
  font-size: 24px;
  font-weight: 800;
  box-shadow: 0 16px 32px rgba(225, 29, 72, 0.24);
}

.login-brand p {
  margin: 0 0 6px;
  color: var(--yt-muted);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.login-brand h1 {
  margin: 0;
  color: var(--yt-text);
  font-size: 28px;
  line-height: 1.15;
}

.login-error {
  margin-bottom: 14px;
  padding: 12px 14px;
  border: 1px solid rgba(225, 29, 72, 0.18);
  border-radius: 14px;
  background: rgba(225, 29, 72, 0.08);
  color: #be123c;
  font-size: 14px;
  line-height: 1.5;
}

.login-fields {
  margin: 0;
  overflow: hidden;
  border: 1px solid var(--yt-line);
  box-shadow: var(--yt-shadow);
}

.login-fields :deep(.van-cell) {
  align-items: center;
}

.login-submit {
  margin-top: 18px;
  height: 46px;
  font-weight: 700;
}
</style>
